<div fxLayout="column inline" class="toggle-button-container">
  <mat-label>{{label | translate}}{{requiredAsterix}}</mat-label>
  <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
    <mat-button-toggle-group [formControl]="control" [multiple]="multiple" [id]="'toggle-buttons-' + formControlName" [name]="formControlName">
      <mat-button-toggle [disabled]="isDisabled" *ngFor="let item of options;" [value]="item.value"
                         [id]="'nc-toggle-button-' + formControlName + '-' + item.value"
                         class="toggle-button">
        <mat-label>
          {{translate ? (item.text | translate) : item.text}}
        </mat-label>
      </mat-button-toggle>
    </mat-button-toggle-group>
    <ng-content></ng-content>
  </div>
</div>
<div class="error-container">
  <mat-error *ngIf="isControlInvalid()">
    <ng-container *ngIf="getErrorMessage() as errorLabel">
      {{ errorLabel.label | translate:errorLabel.parameters }}
    </ng-container>
  </mat-error>
</div>
